import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, Grid } from '@mui/material';
import Sidebar from './filter';
import OrdersList from './order_list';
import { showLoader, hideLoader } from '../../redux/loader/actions';
import subscriptionApi from '../../services/subscribe';
import authApi from '../../services/auth';
import { useNavigate } from 'react-router-dom';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../utils';
import BusinessSelection from '../signin/business_selection';

function Manage_Products() {
    const navigate = useNavigate();
    const organizationItems = useSelector((state) => state.organizationReducer.items);
    const dispatch = useDispatch();
    const userId = getDecryptedCookie('uuid');
    const [searchParams, setSearchParams] = useState({
        products: '',
        fromDate: null,
        toDate: null,
        status: '',
        filterBy: ''
    });
    const [subscriptionData, setSubscriptionData] = useState([]);
    const [rowCountSub, setRowCountSub] = useState(0);
    const [paginationModelSub, setPaginationModelSub] = useState({
        page: 0,
        pageSize: 10
    });
    const [verifyModal, setVerifyModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');

    const validateUserToken = () => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            if (res?.data?.status === true) {
                sessionStorage.setItem('organisationId', res?.data?.uuid);
                getSubscriptionData(res?.data?.uuid);
                if (!res?.data?.has_access_in_current_id && res?.data?.has_access_in_other_id) {
                    setVerifyModal(true);
                }
            }
        };
        const onFailure = (err) => {};
        authApi.validateToken().then(onSuccess, onFailure);
    };

    useEffect(() => {
        validateUserToken();
    }, [paginationModelSub.page, paginationModelSub.pageSize, searchParams, dispatch]);
    const getSubscriptionData = useCallback(
        (id) => {
            dispatch(showLoader());
            const onSuccess = (res) => {
                if (res?.data?.status) {
                    setSubscriptionData(res?.data?.data);
                    setRowCountSub(res?.data?.data?.pagination?.totalItems);
                }

                setTimeout(() => {
                    dispatch(hideLoader());
                }, 2000);
            };
            const onFailure = (err) => {
                dispatch(hideLoader());
                console.error(err?.response?.data?.msg);
                if (err?.response?.status === 401 || err?.response?.status === 403) {
                    navigate('/');
                }
            };
            subscriptionApi
                ?.getAllSubscriptionById(id, paginationModelSub.page + 1, paginationModelSub.pageSize, searchParams)
                .then(onSuccess, onFailure);
        },
        [paginationModelSub.page, paginationModelSub.pageSize, searchParams, dispatch]
    );

    return (
        <Grid container spacing={3} mt={2}>
            <Grid item xs={12} sm={12} md={3}>
                <Sidebar
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    paginationModelSub={paginationModelSub}
                    setPaginationModelSub={setPaginationModelSub}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={9}>
                <OrdersList
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    getSubscriptionData={getSubscriptionData}
                    subscriptionData={subscriptionData}
                    paginationModelSub={paginationModelSub}
                    setPaginationModelSub={setPaginationModelSub}
                    rowCountSub={rowCountSub}
                />
            </Grid>
            <Dialog open={verifyModal} maxWidth='sm' fullWidth>
                <BusinessSelection
                    BackdropProps={{
                        sx: {
                            backdropFilter: 'blur(6px)', // You can adjust the blur intensity
                            backgroundColor: 'rgba(0, 0, 0, 0.4)' // Optional: add a semi-transparent overlay
                        }
                    }}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                />
            </Dialog>
        </Grid>
    );
}
export default Manage_Products;
